/* eslint-disable angular/controller-name */

angular.
module("dx.webapp.skolon").
controller("DxSkolonAuthenticateRouteController", function SkolonAuthenticateRouteController(
	$location,
	$window,

	dxApi,
	DX_URLS
) {
	"use strict";

	var params = $location.search();
	var code = params.code;
	var state = params.state;

	dxApi.v1.skolon.authenticate(code, state).then(function success() {
		$window.location.href = DX_URLS.get("overview");
	}, function fail(res) {
		var data = res.data;
		$location.url(DX_URLS.get("error") + "?error_message=" + data.message + "&request_id=" + data.requestID);
	});
});
